import styled from 'styled-components';
import chevronIconSVG from '../../assets/images/chevron-icon.svg';

const chevronIcon = styled.span`
  background: url(\"${chevronIconSVG}\") no-repeat right center;
  background-size: 15px 10px;
  display: inline-block;
  height: 10px;
  position: relative;
  width: 15px;
  cursor: pointer;
`;

export default chevronIcon;
